export default {
    isScrolledIntoView(element, offsetTop, offsetBottom){
        offsetTop = offsetTop || 0;
        offsetBottom = offsetBottom || 0;
        const rect = element.getBoundingClientRect();
        return rect.top + offsetTop < window.innerHeight && rect.bottom + offsetBottom >= 0;
    },
    isFullyScrolledIntoView(element){
        const rect = element.getBoundingClientRect();
        return rect.top >= 0 && rect.bottom <= window.innerHeight;
    },
}
